import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteFavoriteGameService} from "../../services/games/miniGames/favoriteGames.service";

const useDeleteFavoriteGame = () => {
  const query = useQueryClient();
  const {isPending, isSuccess, mutate, error, isError} = useMutation({
    mutationKey: ["deleteFavoriteGame"],
    mutationFn: deleteFavoriteGameService,
    onSuccess: _data => {
      query.invalidateQueries({queryKey: ["listFavoriteGames"]});
    },
  });

  return {
    isSuccessDeleted: isSuccess,
    isErrorDeleted: isError,
    errorDeleted: error,
    isPendingDeleted: isPending,
    deleteFavoriteGame: mutate,
  };
};

export default useDeleteFavoriteGame;
